//
// locale_ta.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/ta.json';
import localeData from "react-intl/locale-data/ta.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
